/* eslint-disable */
import * as React from 'react';
import {QueryProvider} from '@thd-nucleus/data-sources';
import {useLocation, useParams} from '@thd-olt-component-react/router';
import {LayoutMapper} from "./LayoutMapper";
import {AppContext} from "@thd-nucleus/app-render";

export const LayoutContainer = () => {
  const {search: querystring, pathname} = useLocation();
  const pathWithQueryParams = `${pathname}${querystring}`;

  const {instance} = React.useContext(AppContext);
  let customerType = instance?.customer?.type;
  const previewLink = instance?.headers?.['x-content-preview'] !== undefined
    || pathWithQueryParams.includes('contentPV')
    || pathWithQueryParams.includes('render*')
    || pathWithQueryParams.includes('bassPV');

  const {slug} = useParams();
  let pageId = slug;

  // This is specific for being able to render pages for Contentful's previews
  if (previewLink && (pageId.endsWith('-b2c') || pageId.endsWith('-b2b'))) {
    customerType = pageId.slice(-3);
    pageId = pageId.replace(/-b2[b|c]$/, '');
  }

  return (
    <QueryProvider cacheKey="speciality-content-layout">
      <LayoutMapper
        pageId={pageId}
        customerType={customerType}
        previewLink={previewLink}
        pathWithQueryParams={pathWithQueryParams}
        slug={slug}
      />
    </QueryProvider>
  )
};

LayoutContainer.propTypes = {};

LayoutContainer.displayName = 'layoutContainer';

